import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#f5f5f5] py-16 md:py-20 lg:py-24 px-4 border-t-4 border-gray-300" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <div className="bg-white p-12 md:p-16 rounded-lg border-4 border-gray-300 shadow-lg" data-id="element-214">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-10 text-center leading-tight" data-id="element-215">
            El problema no es la técnica.{' '}
            <span className="text-[#c41e3a]" data-id="element-216">Es la falta de criterio.</span>
          </h2>
          <div className="w-24 h-1 bg-[#c41e3a] mx-auto mb-10" data-id="element-217"></div>
          <p className="text-2xl md:text-3xl text-gray-700 leading-relaxed text-center mb-8" data-id="element-218">
            La mayoría de los cursos enseñan qué hacer, pero no explican por qué
            hacerlo. Eso genera barberos inseguros, errores repetidos y cortes
            inconsistentes.
          </p>
          <p className="text-2xl md:text-3xl text-gray-900 font-black text-center" data-id="element-219">
            El Método Barber Pro fue creado para cambiar eso.
          </p>
        </div>
      </div>
    </section>;
}